import React, { useState } from "react";
import MainModal from "components/ModalMain";
import Button from "components/Button";
import Input from "components/Input";
import ModalGeneralFailed from "screens/ModalGeneralFailed";
import { useMutation } from "@apollo/client";
import { CHANGE_CONTACT } from "graphql/service";
import { Head, Container, Footer } from "./styles";
import ModalVerification from "screens/ModalVerification";

const ModalNewEmailAddress = ({
  hidden,
  isOpen,
  setIsOpen,
  refetch,
  token
}) => {

  const [verificationIsOpen, setVerificationIsOpen] = useState(false);
  const [failedIsOpen, setFailedIsOpen] = useState(false);
  const [email, setEmail] = useState("");
  const [emailError, setEmailError] = useState(false);

  const [changeContact, { loading, error }] = useMutation(CHANGE_CONTACT, {
    onCompleted: (data) => {
      setIsOpen(false);
      setVerificationIsOpen(true);
      setFailedIsOpen(false);
    },
    onError: (error) => {
      setIsOpen(false);
      setVerificationIsOpen(false);
      setFailedIsOpen(true);
    }
  });

  const handleContinue = () => {
    if (email.trim() === "" || !email.includes("@")) {
      setEmailError(true);
      return;
    }
    changeContact({
      variables: {
        input: {
          contactType: "EMAIL",
          sessionToken: token,
          newValue: email
        }
      }
    });
  };

  return (
    <>
      <MainModal
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        className="modal-success"
        hidden={hidden}
        additionalstyle={`
          max-width: 500px;
          .modal-content{
            .close {
              z-index: 200;
            }          
            .modal-body {
              height: 100%;
              padding: 24px;
            }
          }
          top: 139px;
        `}
      >
        <Head>
          Enter New Email Address
        </Head>
        <Container>
          <Input
            title="EMAIL ADDRESS"
            required
            error={emailError}
            errorMessage="Please enter a valid Email Address"
            value={email}
            onChange={(e) => {
              setEmail(e.target.value);
              if (emailError) {
                setEmailError(false);
              }
            }}
            additionalstyle={`
              width: 100%;
            `}
          />
        </Container>
        <Footer>
          <Button
            success
            additionalstyle={`
              width: 97px;
            `}
            onClick={handleContinue}
            data-loading={loading}
          >
            {loading ? null : "Continue"}
          </Button>
        </Footer>
      </MainModal>
      <ModalVerification
        isOpen={verificationIsOpen}
        setClose={() => {
          setVerificationIsOpen(false);
          setEmail("")
        }}  
        refetch={refetch}
        token={token}
        email={email}
      />
      <ModalGeneralFailed
        isOpen={failedIsOpen}
        setClose={()=> {
          setEmail("");
          setFailedIsOpen(false);
        }}
        loading={loading}
        errorMessage={error?.message || "Failed to change email address. Please try again."}
        retryFunction={handleContinue}
        type="changeEmail"
      />
    </>
  );
};

export default ModalNewEmailAddress;